exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SignInButton__container___1_0fX .SignInButton__icon___rmtYG {\n  margin-right: 10px;\n  height: 12px;\n  vertical-align: initial; }\n  .SignInButton__container___1_0fX .SignInButton__icon___rmtYG path {\n    fill: #303030;\n    transition: fill 300ms ease; }\n\n.SignInButton__container___1_0fX:hover .SignInButton__icon___rmtYG path {\n  fill: #ff4d66; }\n\n.SignInButton__text___1UVz2 {\n  font-weight: 600;\n  font-size: 15px;\n  line-height: 15px;\n  font-family: \"Poppins\"; }\n", ""]);

// exports
exports.locals = {
	"container": "SignInButton__container___1_0fX",
	"icon": "SignInButton__icon___rmtYG",
	"text": "SignInButton__text___1UVz2"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/containers/UserMenu/SignInButton/SignInButton.scss
// module id = 3993
// module chunks = 6